import React, { useContext } from 'react';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import {
  BiData,
  RedirectToLoginBiEvent,
  TopNavMenuClickBiEvent,
} from '@wix/da-bi/pkg/events';
import MenuList from '@wix/da-ds/pkg/Dropdown/MenuList';
import {
  useSaleBannerItem,
  useFakeContentFilterItem,
  useFakeAISuppressionItem,
  useBuyCoreItem,
  useThemeToggleItem,
  useHelpItem,
  useTermsItem,
  usePrivacyPolicyItem,
} from '../../../items';
import { UserMenuContext } from '../../UserMenuContext';
import UserMenuAvatar from '../UserMenuAvatar';

import userMenuStyles from '../../UserMenuMobile.scss';
import s from './LoggedOutMenu.scss';

export interface Props {
  hideNotificationCount?: boolean;
  disableThemeSwitcher?: boolean;
}

const LoggedOutMenu: React.FC<Props> = ({ disableThemeSwitcher }) => {
  const { t } = useTranslation();
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);

  const contentFilterItem = useFakeContentFilterItem();
  const aiSuppressionItem = useFakeAISuppressionItem();
  const saleBannerItem = useSaleBannerItem();
  const themeToggleItem = useThemeToggleItem();
  const buyCoreItem = useBuyCoreItem();
  const helpItem = useHelpItem();
  const termsItem = useTermsItem();
  const privacyPolicyItem = usePrivacyPolicyItem();

  const tabIndex = isUserMenuOpen ? 0 : -1;
  const items = [
    {
      className: userMenuStyles['top-group'],
      items: [
        {
          label: (
            <span className={s['anon-hello']}>
              {t('siteHeaderMobile.userMenu.hello')}
            </span>
          ),
          suffix: <UserMenuAvatar />,
        },
      ],
    },
    {
      className: userMenuStyles['group'],
      items: [
        {
          label: t('siteHeaderMobile.userMenu.signIn'),
          link: Url.loginLink(),
          biData: BiData<TopNavMenuClickBiEvent>({
            evid: 702,
            link_url: Url.loginLink(),
            menu_item: 'login',
            menu_name: 'profile',
          }),
          tabIndex,
        },
        {
          label: t('siteHeaderMobile.userMenu.join'),
          link: Url.joinLink(),
          biData: BiData<RedirectToLoginBiEvent>({
            evid: 240,
            referral_info: ReferralType.HEADER,
          }),
          tabIndex,
        },
        buyCoreItem,
        saleBannerItem,
        !disableThemeSwitcher && themeToggleItem,
        contentFilterItem,
        aiSuppressionItem,
      ],
    },
    {
      className: userMenuStyles['group'],
      items: [helpItem, termsItem, privacyPolicyItem],
    },
  ];

  return (
    <MenuList
      renderOnSSR
      id="site-header-user-menu"
      className={userMenuStyles['user-menu']}
      itemsFillContainerWidth={true}
      items={items}
    />
  );
};
LoggedOutMenu.displayName = 'LoggedOutMenu';

export default LoggedOutMenu;
